import { cva } from 'class-variance-authority'

export const alertVariants = cva(
  `
    relative
    w-full
    rounded-2xl
    border-1
    p-4
    [&>svg~*]:pl-7
    [&>svg]:absolute
    [&>svg]:left-4
    [&>svg]:top-[20px]
    [&>svg]:text-foreground
  `,
  {
    variants: {
      variant: {
        default: `
          bg-moss-0
          border-moss-50
          text-neutral-600
          [&>svg]:text-neutral-600
        `,
        success: `
          bg-green-0
          border-green-50
          text-green-100
          [&>svg]:text-green-100
        `,
        warning: `
          bg-yellow-0
          border-yellow-50
          text-yellow-200
          [&>svg]:text-yellow-200
        `,
        error: `
          bg-red-0
          border-red-50
          text-red-100
          [&>svg]:text-red-200
        `,
        priority: `
          bg-orange-0
          border-orange-50
          text-orange-200
          [&>svg]:text-orange-200
        `,
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const alertTitleStyles = cva(
  `
    font-geist
    text-base
    font-medium
    leading-[130%]
  `,
  {
    variants: {
      variant: {
        default: 'text-neutral-600',
        success: 'text-green-100',
        warning: 'text-yellow-200',
        error: 'text-red-100',
        priority: 'text-orange-200',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export const alertDescriptionStyles = cva(
  `
    text-sm
    font-normal
    [&_p]:leading-relaxed
    leading-[130%]
  `
)

export const inlineLinkStyles = cva(
  `
    inline-flex
    items-center
    gap-0
    cursor-pointer
    text-sm
    hover:text-current
    underline
    underline-offset-auto
    p-0
    leading-none
    align-baseline
    ml-2
    text-neutral-900
    label-xs
  `
)

export const ctaStyles = cva(
  `
  text-sm
  `
)
